import axios from '@/utils/request.js'

// 获取我的任务列表分页
export function GetMyTaskPages(data) {
    return axios({
        url: '/oa_tcs/oa/tcs/Task/GetMyTaskPages',
        method: 'Get',
        params: data
    })
}

// 获取我的指派列表分页
export function GetMyAssignmentPages(data) {
    return axios({
        url: '/oa_tcs/oa/tcs/Task/GetMyAssignmentPages',
        method: 'Get',
        params: data
    })
}

// 获取待我验收列表分页
export function GetVerifyingPageList(data) {
    return axios({
        url: '/oa_tcs/oa/tcs/Verifying/GetVerifyingPageList',
        method: 'Get',
        params: data
    })
}

//获取团队信息
export function GetTeamInfoByCurrentEmpId() {
    return axios({
        url: '/oa_tcs/oa/tcs/Task/GetTeamInfoByCurrentEmpId',
        method: 'Get'
    })
}

// 获取任务详情
export function GetTaskDataById(data) {
    return axios({
        url: '/oa_tcs/oa/tcs/Task/GetTaskDataById',
        method: 'Get',
        params: data
    })
}

//更新任务状态
export function UpdateTaskStatus(data) {
    return axios({
        url: '/oa_tcs/oa/tcs/Task/UpdateTaskStatus',
        method: 'post',
        data: data
    })
}

//更新完成状态
export function UpdateFinishStatus(data) {
    return axios({
        url: '/oa_tcs/oa/tcs/Task/UpdateFinishStatus',
        method: 'post',
        data: data
    })
}

// 保存新增任务的数据
export function SaveAddTaskDataWithAndroid(data) {
    return axios({
        url: '/oa_tcs/oa/tcs/Task/SaveAddTaskDataWithAndroid',
        method: 'post',
        data
    })
}

//编辑保存
export function UpdateById(data) {
    return axios({
        url: '/oa_tcs/oa/tcs/Task/UpdateById',
        method: 'post',
        data: data
    })
}

// 获取参会人接口
export function GetMeetingPersonnel(meeting_id) {
    return axios({
        url: '/oa_ads/oa/ads/MeetingPersonnel/GetList',
        method: 'post',
        data: {meeting_id}
    })
}
//获取代理人是本人的emp_id的数据
export function GetAgentWithMe() {
    return axios({
        url: '/oa_tcs/oa/tcs/Agent/GetAgentWithMe',
        method: 'Get',
    })
}
